import HttpFactory from 'http-service-v3'
export default function campaignSolutionFactory() {
    const http = HttpFactory()
    return {
      getCampaignSolution(campaignSolutionId) {
        return http
          .get(http.wsaDomain + `/campaignsolution/v2/get/${campaignSolutionId}`)
          .then(response => { return response.data })
      },
      getPublicCampaignSolutions(vertical) {
        return http
          .get(http.wsaDomain + `/campaignsolution/v2/getpubliccampaignsolutionlist/${vertical}`)
          .then(response => { return response.data })
      },
      getPublicCampaignSolutionsV3(requestData) {
        return http
          .get(http.wsaDomain + `/campaignsolution/v3/getpubliccampaignsolutionlist/${btoa(JSON.stringify(requestData))}`)
          .then(response => { return response.data })
      },
      getPublicCheckoutSolutions(vertical) {
        return http
          .get(http.wsaDomain + `/campaignsolution/v2/getpubliccheckoutsolutionlist/${vertical}`)
          .then(response => { return response.data })
      },
      getAllTemplates(campaignSolutionId) {
        return http
          .get(http.wsaDomain + `/campaignsolution/v2/getalltemplates/${campaignSolutionId}`)
          .then(response => { 
            if (!response.data) return []
            response.data.forEach(templatesByFormat => {
              templatesByFormat.templates.forEach(template => {
                template.blueprint = JSON.parse(template.blueprint)
                template.properties = JSON.parse(template.properties)
                template.properties.templateJson = JSON.parse(template.properties.templateJson)
                template.transitionSettings = JSON.parse(template.transitionSettings)
              })
            })
            return response.data 
          })
      },
      getAllThumbnailsForSolution(campaignSolutionId, callback) {
        return http.get(http.wsaDomain + `/campaignsolution/v2/getallthumbnails/${campaignSolutionId}`)
          .then(response => { return response.data })
      },
    }
  }